import React from 'react';
import {faCheckCircle} from '@fortawesome/pro-solid-svg-icons';
import {Button} from '@mui/material';
import {
	FallbackMessage,
	FallbackMessageProps,
} from '@netx/core-components/FallbackMessage';
import {AuthMessage, AuthActionLabel} from '../../locales';

export interface RegisterAwaitingApprovalProps extends FallbackMessageProps {
	onCancel?: () => void;
}

export const RegisterAwaitingApprovalPrimitive = ({
	onCancel,
	...props
}: RegisterAwaitingApprovalProps) => {
	return (
		<FallbackMessage
			icon={faCheckCircle}
			variant="light"
			title={AuthMessage.AWAITING_APPROVAL}
			{...props}
		>
			<Button
				variant="text"
				onClick={() => {
					onCancel?.();
				}}
			>
				{AuthActionLabel.RETURN_TO_LOGIN}
			</Button>
		</FallbackMessage>
	);
};

export const RegisterAwaitingApproval = RegisterAwaitingApprovalPrimitive;

export default RegisterAwaitingApproval;
